<div style="position: relative" #searchCompTemplate>
  <div class="menu-arrow" *ngIf="menuOpened$ | async"></div>
  <mat-form-field class="search-field q9-without-label" [appearance]="'outline'">
    <mat-spinner
      strokeWidth="1"
      diameter="20"
      class="search-field__spinner"
      *ngIf="isLoading; else iconsTemplate"></mat-spinner>

    <ng-template #iconsTemplate>
      <!--      <mat-icon-->
      <!--        svgIcon="search"-->
      <!--        *ngIf="searchIsEmpty; else clearButtonContainerTemplate"-->
      <!--        class="search-field__icon"-->
      <!--      >-->
      <!--      </mat-icon>-->
      <!--      <ng-template>-->
      <!--        <button-->
      <!--          class="search-field__icon search-field__clear-btn"-->
      <!--          [disableRipple]="true"-->
      <!--          aria-label="Clear"-->
      <!--          #clearButton-->
      <!--          mat-icon-button-->
      <!--        >-->
      <!--          <mat-icon svgIcon="close" class="clear-btn__icon"></mat-icon>-->
      <!--        </button>-->
      <!--      </ng-template>-->
    </ng-template>
    <div class="search-field-container">
      <input
        type="text"
        placeholder="{{ 'TOOLBAR.SEARCH' | translate }}"
        #searchTemplate
        [formControl]="searchControl"
        (focus)="onFocus()"
        (blur)="onBlur()"
        class="search-field__input"
        autocomplete="off"
        matInput />
      <button
        *ngIf="!searchIsEmpty"
        class="search-field__icon search-field__clear-btn"
        [disableRipple]="true"
        aria-label="Clear"
        #clearButton
        mat-icon-button>
        <mat-icon svgIcon="close" class="clear-btn__icon"></mat-icon>
      </button>
    </div>
  </mat-form-field>
  <div *ngIf="menuOpened$ | async" class="search-result-container mat-elevation-z8">
    <div
      *ngIf="showProFeature"
      class="search-result-container__pro-feature"
      appClickOutside
      (clickOutside)="catchClickOutside($event)"
      (click)="$event.stopPropagation()">
      {{ proFeatureMsg | translate }}
    </div>
    <div
      *ngIf="(diagramSearch$ | async).diagrams"
      appClickOutside
      (clickOutside)="catchClickOutside($event)"
      (click)="$event.stopPropagation()">
      <div
        *ngIf="!(diagramSearch$ | async).count && !showProFeature; else foundDiagrams"
        class="search-result-container__no-result">
        {{ 'SEARCH.NO_RESULTS' | translate }}
      </div>
      <ng-template #foundDiagrams>
        <div class="search-result-container__total">
          {{ 'SEARCH.TOTAL_DIAGRAMS' | translate }}: {{ (diagramSearch$ | async).count }}
        </div>
        <table class="results-table">
          <thead class="results-table__head">
            <tr>
              <th class="results-table__diagram-title">
                {{ 'SEARCH.DIAGRAM_TITLE' | translate }}
              </th>
              <th class="results-table__level-title">
                {{ 'SEARCH.LEVEL_TITLE' | translate }}
              </th>
              <th class="results-table__map-title">
                {{ 'SEARCH.MAP_TITLE' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let diagram of (diagramSearch$ | async).diagrams">
              <td
                class="results-table__diagram-name"
                #diagramName
                [matTooltip]="diagram.name"
                [matTooltipShowDelay]="400"
                [matTooltipHideDelay]="400"
                [matTooltipPosition]="'left'"
                [matTooltipDisabled]="$any(diagramName)?.tooltipDisabled"
                [matTooltipClass]="{'break-word': true}"
                (click)="openDiagram(diagram)">
                {{ diagram.name | htmlEncoder: true }}
              </td>
              <td>
                <div class="results-table__level-cell">
                  <span class="results-table__level-cell_level">{{ diagram.levelNumber }}</span>
                </div>
              </td>
              <td
                class="results-table__map-name"
                #diagramMapName
                [matTooltip]="diagram.map.name"
                [matTooltipShowDelay]="400"
                [matTooltipHideDelay]="400"
                [matTooltipPosition]="'left'"
                [matTooltipDisabled]="$any(diagramMapName)?.tooltipDisabled"
                [matTooltipClass]="{'break-word': true}">
                {{ diagram.map.name | htmlEncoder: true }}
              </td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </div>
  </div>
</div>
